import React, { ReactNode } from 'react';
import breakpoints from 'src/integration/styles/breakpoints';
import colors from 'src/integration/styles/colors';
import styled, { css } from 'styled-components';

export type StatusType = 'success';

interface ComponentProps extends Component {
  children: ReactNode;
  type?: StatusType;
  disablePadding?: boolean;
  backgroundColor?: string;
  height?: string;
}

const Root = styled.div<{ $type?: StatusType; $disablePadding?: boolean; $background?: string; $height?: string }>`
  ${({ $type, $disablePadding, $background, $height = '100%' }) => css`
    display: inline-block;
    position: relative;
    background: ${$background || '#fff'};
    border-radius: 1rem;
    border: 1px solid #e8e9ec;
    padding: ${$disablePadding ? '0' : '1.5rem'};
    height: ${$height};
      
    ${breakpoints.desktop`
      padding: ${$disablePadding ? '0' : '1rem 1.5rem 1.5rem'};
    `}

    ${breakpoints.desktopLarge`
      padding: ${$disablePadding ? '0' : '1.5rem'};
    `}

    ${!$background &&
      css`
          background-color: #fff;
          box-shadow: 0 0.5rem 1rem 0 #00000014;
          box-shadow: 0 0 0.25rem 0 #0000000A;
      `} 
    }
  
    ${$type === 'success' &&
      css`
        background: ${colors.text.success};
      `}
    `}
`;

const WhiteBox = ({ className, children, type, disablePadding, backgroundColor, height}: ComponentProps) => {
  return (
    <Root $type={type} className={className} $disablePadding={disablePadding} $background={backgroundColor} $height={height}>
      {children}
    </Root>
  );
};

export default WhiteBox;
